import { Link } from 'react-router-dom';
import { Crane } from '../components/mascot/Crane';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <Crane pose="sympathetic" size="lg" />
        <h1 className="text-4xl font-bold text-primary mt-6 mb-4">404</h1>
        <p className="text-xl text-text-light mb-8">
          This fold of the map doesn't exist.
        </p>
        <Link to="/" className="btn-primary">
          Return to the Hunt
        </Link>
      </div>
    </div>
  );
}
